/* eslint-disable */

import axios from '@/plugins/axios'
import environment from "@/assets/js/environment";
import * as Sentry from "@sentry/browser";
import Cookies from 'js-cookie';

import UserService from '@/services/users'

const state = {
    token: null,
    loggedUser: null,
}

const mutations = {
    setToken(state, token) {
        state.token = token
        Cookies.set('DODO_TOKEN', token, {
            domain: environment.cookiesDomain,
            path: '/'
        })
        axios.rasaApi.defaults.headers.common['Authentication-Token'] = token
    },

    setLoggedUser(state, user) {
        state.loggedUser = user
        Cookies.set('DODO_USER', JSON.stringify(user), {
            domain: environment.cookiesDomain,
            path: '/'
        })
    },
}

const actions = {
    auth({ commit, dispatch }, token) {
        return new Promise(async (resolve, reject) => {
            if (token) {
                commit('setToken', token)
            } else {
                console.log('Autenticação sem token')
                const url = new URL(window.location.href)
                const cleanUrl = url.origin
                Cookies.set('urlContinue', cleanUrl, {
                    domain: environment.cookiesDomain,
                    path: '/'
                })
                window.location = environment.authUrl
                return
            }

            try {
                const res = await UserService.getUserMe()
                commit('setLoggedUser', res.data)
                const urlContinue = Cookies.get('urlContinue')
                if (urlContinue) {
                    Cookies.remove('urlContinue', {
                        domain: environment.cookiesDomain,
                        path: '/'
                    })
                    window.location.href = urlContinue
                    return
                }
                resolve()
            } catch (error) {
                console.error('Error getting user data:', error)
                dispatch('logout')
                reject(error)
            }
        })
    },

    check_auth() {
        if (state.loggedUser && state.token) {
            return true
        }

        const token = Cookies.get('DODO_TOKEN')
        const userStr = Cookies.get('DODO_USER')

        if (token && userStr) {
            const user = JSON.parse(userStr)
            state.token = token
            state.loggedUser = user
            axios.rasaApi.defaults.headers.common['Authentication-Token'] = token
            Sentry.setUser({
                id: user.id,
                username: user.name,
            });
            return true
        }

        return false
    },
    auth({ commit, dispatch }, token) {
        return new Promise(async (resolve, reject) => {
            if (token) {
                commit('setToken', token)
            } else {
                console.log('Autenticação sem token')
                const currentUrl = window.location.href
                Cookies.set('urlContinue', currentUrl, {
                    domain: environment.cookiesDomain,
                    path: '/'
                })
                window.location = environment.authUrl
            }
            await UserService.getUserMe().then(res => {
                commit('setLoggedUser', res.data)
                resolve()
            }).catch(() => {
                // window.alert('desconectando')
                dispatch('logout')
            })
        })
    },
    logout() {
        Cookies.set('urlContinue', window.location.href, {
            domain: environment.cookiesDomain,
            path: '/'
        })

        state.loggedUser = null
        state.token = null
        
        Cookies.remove('DODO_TOKEN', {
            domain: environment.cookiesDomain,
            path: '/'
        })
        Cookies.remove('DODO_USER', {
            domain: environment.cookiesDomain,
            path: '/'
        })
    }
}

const getters = {
    getLoggedUser(state) {
        return state.loggedUser
    },
}

export default {
    state,
    mutations,
    actions,
    getters,
};